<template>
    <div v-if="cause.toLowerCase() == 'unauthorized'">
        <h2>{{ permissionDeniedMessageTitle }}</h2>
        <h3 v-for="(line, index) in permissionDeniedMessageLines" :key="index">{{ line }}</h3>
    </div>
    <div v-else>
        <h2>Ismeretlen hiba!</h2>
    </div>
</template>

<script>

  import Config from 'Configuration';

  export default {
      name: "ErrorView",
      props: {
          isTranslated: Boolean,
          cause: {
              type: String,
              default: 'unknown'
          }
      },
      computed: {
        permissionDeniedMessageTitle() {
          if(this.$props.isTranslated)
            return Config.message.permissionDenied.en.title;
          else
            return Config.message.permissionDenied.hu.title;
        },
        permissionDeniedMessageLines() {
          if(this.$props.isTranslated)
            return Config.message.permissionDenied.en.contentLines;
          else
            return Config.message.permissionDenied.hu.contentLines;
        }
      }
  }
</script>

<style scoped>

</style>